<template>
  <v-layout row wrap>
    <v-flex xs4 v-if="false">
      <v-btn color="primary" height="200px" dark large
        >Total Income
        {{ $app.formatMoney(100000) }}
        <v-icon dark right>check_circle</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs4 v-if="false">
      <v-btn color="accent" dark large
        >Total Blocked
        {{ $app.formatMoney(100000) }}
        <v-icon dark right>check_circle</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs4 v-if="false">
      <v-btn color="success" dark large
        >Total Blocked
        {{ $app.formatMoney(100000) }}
        <v-icon dark right>check_circle</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs4 v-if="false">
      <v-btn color="success" dark large
        >Total Deliveries
        {{ $app.formatMoney(100000) }}
        <v-icon dark right>check_circle</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs12 md12>
      <riders></riders>
      <!-- <stats-card url="income" chart-type="bar" title="Income Per Month"></stats-card> -->
    </v-flex>
  </v-layout>
</template>

<script>
import StatsCard from './StatsCard'
import Riders from './Riders'

export default {
  name: 'AdminDashboard',
  components: { StatsCard, Riders }
}
</script>

<style s Riderscoped></style>



// WEBPACK FOOTER //
// src/components/AdminDashboard.vue